import { cn } from '@shared/cove-ui';
import { useId } from 'react';

export default function LogoPrimary({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="467"
      viewBox="0 0 467 144"
      fill="none"
      className={cn('text-cove-green cursor-pointer', className)}
      {...props}
    >
      <g clipPath={`url(#clip0_${id})`}>
        <path
          d="M55.46 40.58C60.72 37.78 66.41 36.38 72.54 36.38C80 36.38 86.62 38.48 92.42 42.67C98.21 46.87 102.24 52.56 104.51 59.75H121.89C120.96 51.49 118.23 44.4 113.7 38.48C109.17 32.56 103.38 27.99 96.32 24.8C89.26 21.6 81.34 20.01 72.55 20.01C62.83 20.01 53.9 22.08 45.78 26.2C37.66 30.33 31.16 36.29 26.3 44.08C21.43 51.86 19 61.22 19 72.14C19 83.06 21.43 92.22 26.29 100.01C31.15 107.8 37.64 113.73 45.77 117.79C53.89 121.85 62.82 123.88 72.54 123.88C81.33 123.88 89.32 122.28 96.51 119.09C103.7 115.89 109.53 111.27 113.99 105.21C118.45 99.15 121.08 91.99 121.88 83.74H104.7C102.43 91.2 98.64 96.99 93.31 101.12C87.98 105.25 81.06 107.31 72.53 107.31C66.27 107.31 60.54 105.95 55.35 103.22C50.16 100.49 45.99 96.5 42.86 91.23C39.73 85.97 38.17 79.61 38.17 72.15C38.17 64.69 39.73 57.94 42.86 52.67C45.99 47.41 50.18 43.38 55.44 40.58H55.46Z"
          fill="currentColor"
        />
        <path
          d="M216.58 26.19C208.59 22.06 199.73 20 190.01 20C180.29 20 171.36 22.07 163.24 26.19C155.12 30.32 148.66 36.28 143.86 44.07C139.07 51.86 136.67 61.22 136.67 72.14C136.67 83.06 139.07 92.19 143.86 99.91C148.65 107.64 155.11 113.56 163.24 117.69C171.36 121.82 180.29 123.88 190.01 123.88C199.73 123.88 208.59 121.81 216.58 117.69C224.57 113.56 230.96 107.64 235.76 99.91C240.55 92.19 242.95 82.93 242.95 72.14C242.95 61.35 240.55 51.86 235.76 44.07C230.97 36.28 224.57 30.32 216.58 26.19ZM219.08 91.21C215.95 96.47 211.82 100.47 206.69 103.2C201.56 105.93 196 107.29 190.01 107.29C184.02 107.29 178.22 105.93 173.03 103.2C167.84 100.47 163.67 96.48 160.54 91.21C157.41 85.95 155.85 79.59 155.85 72.13C155.85 64.67 157.45 57.88 160.64 52.55C163.84 47.23 168.03 43.2 173.23 40.46C178.42 37.73 184.02 36.36 190.01 36.36C196 36.36 201.56 37.76 206.69 40.56C211.82 43.36 215.94 47.42 219.08 52.75C222.21 58.08 223.77 64.54 223.77 72.13C223.77 79.72 222.2 85.95 219.08 91.21Z"
          fill="currentColor"
        />
        <path
          d="M295.06 98.67L266.56 22H245.58L286.13 121.68H304.11L345.06 22H324.29L295.06 98.67Z"
          fill="currentColor"
        />
        <path
          d="M443.55 45.27C440.02 36.95 434.59 30.66 427.27 26.39C419.94 22.13 410.89 20 400.1 20C389.31 20 380.72 22.2 372.73 26.59C364.74 30.98 358.48 37.08 353.95 44.87C349.42 52.66 347.16 61.75 347.16 72.14C347.16 82.53 349.49 91.39 354.15 99.11C358.81 106.84 365.2 112.89 373.33 117.29C381.45 121.68 390.71 123.88 401.1 123.88C409.89 123.88 417.55 122.35 424.07 119.29C430.59 116.23 435.86 112.1 439.85 106.9C443.84 101.71 446.37 95.85 447.44 89.32H429.26C427.53 94.65 424.2 98.98 419.27 102.3C414.34 105.63 408.21 107.29 400.89 107.29C394.36 107.29 388.6 105.96 383.61 103.3C378.62 100.64 374.62 96.98 371.62 92.31C368.62 87.65 366.79 82.32 366.13 76.33H447.83C448.49 63.94 447.06 53.59 443.53 45.27H443.55ZM367.34 61.55C369.2 53.96 373 47.87 378.73 43.27C384.45 38.68 391.65 36.38 400.3 36.38C408.02 36.38 414.55 38.55 419.88 42.87C425.21 47.2 428.14 53.43 428.67 61.55H367.34Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={`clip0_${id}`}>
          <rect
            width="429"
            height="103.88"
            fill="white"
            transform="translate(19 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
